import React from 'react';
import { Link } from 'react-router-dom';

function Section({ title, children }) {
  return (
    <section className="space-y-3">
      <h2 className="text-lg font-semibold text-[#d4af37]">{title}</h2>
      <div className="text-[#c0c0c0] text-sm leading-relaxed space-y-2">{children}</div>
    </section>
  );
}

export default function CookiePolicyPage() {
  return (
    <div className="min-h-screen bg-[#0a0e17] text-[#f5f5f0] py-16 px-6">
      <div className="max-w-2xl mx-auto space-y-10">
        <div>
          <h1 className="text-3xl font-bold mb-1">Política de Cookies</h1>
          <p className="text-[#8a8a8a] text-sm">
            Última actualización: abril de 2026 — Conforme a la Directiva ePrivacy (2002/58/CE)
          </p>
        </div>

        <Section title="1. Cookies que utilizamos">
          <p>
            Esta tienda utiliza exclusivamente <strong>cookies técnicas esenciales</strong> para el
            funcionamiento de la sesión de usuario. No usamos cookies de seguimiento, análisis ni
            publicidad.
          </p>
          <table className="w-full border-collapse text-xs mt-2">
            <thead>
              <tr className="border-b border-[#2a3444]">
                <th className="text-left py-2 pr-4 text-[#f5f5f0]">Nombre</th>
                <th className="text-left py-2 pr-4 text-[#f5f5f0]">Tipo</th>
                <th className="text-left py-2 pr-4 text-[#f5f5f0]">Duración</th>
                <th className="text-left py-2 text-[#f5f5f0]">Finalidad</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#2a3444]">
              <tr>
                <td className="py-2 pr-4 font-mono">access_token</td>
                <td className="py-2 pr-4">HttpOnly, Secure</td>
                <td className="py-2 pr-4">15 minutos</td>
                <td className="py-2">Autenticación de sesión activa</td>
              </tr>
              <tr>
                <td className="py-2 pr-4 font-mono">refresh_token</td>
                <td className="py-2 pr-4">HttpOnly, Secure</td>
                <td className="py-2 pr-4">7 días</td>
                <td className="py-2">Renovación automática de sesión</td>
              </tr>
              <tr>
                <td className="py-2 pr-4 font-mono">lxi_cookie_consent</td>
                <td className="py-2 pr-4">localStorage</td>
                <td className="py-2 pr-4">Permanente</td>
                <td className="py-2">Registro de aceptación de este aviso</td>
              </tr>
            </tbody>
          </table>
        </Section>

        <Section title="2. Cookies de terceros">
          <p>
            No instalamos cookies de terceros. Stripe (procesador de pagos) puede establecer cookies
            propias durante el proceso de pago, sujetas a su propia{' '}
            <a
              href="https://stripe.com/privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#d4af37] hover:underline"
            >
              política de privacidad
            </a>
            .
          </p>
        </Section>

        <Section title="3. Cómo gestionar o eliminar cookies">
          <p>
            Puedes eliminar las cookies en cualquier momento desde la configuración de tu navegador:
          </p>
          <ul className="list-disc list-inside space-y-1 ml-2">
            <li>Chrome: Ajustes → Privacidad → Borrar datos de navegación</li>
            <li>Firefox: Opciones → Privacidad → Limpiar historial reciente</li>
            <li>Safari: Preferencias → Privacidad → Gestionar datos de sitios web</li>
            <li>Edge: Configuración → Privacidad → Borrar datos de exploración</li>
          </ul>
          <p>
            Ten en cuenta que eliminar <code className="font-mono text-xs bg-[#1a2332] px-1 py-0.5 rounded">access_token</code> y{' '}
            <code className="font-mono text-xs bg-[#1a2332] px-1 py-0.5 rounded">refresh_token</code>{' '}
            cerrará tu sesión en la tienda.
          </p>
        </Section>

        <Section title="4. No se requiere consentimiento para cookies técnicas">
          <p>
            Conforme al Art. 5.3 de la Directiva ePrivacy y su transposición en la legislación
            alemana (§ 25 TDDDG), las cookies estrictamente necesarias para la prestación del
            servicio solicitado por el usuario (como las cookies de sesión) están exentas del
            requisito de consentimiento previo.
          </p>
          <p>
            Las cookies <code className="font-mono text-xs bg-[#1a2332] px-1 py-0.5 rounded">access_token</code> y{' '}
            <code className="font-mono text-xs bg-[#1a2332] px-1 py-0.5 rounded">refresh_token</code>{' '}
            son técnicamente necesarias para que puedas iniciar sesión y realizar compras. Sin ellas,
            la tienda no puede funcionar correctamente.
          </p>
        </Section>

        <p className="text-[#8a8a8a] text-sm border-t border-[#2a3444] pt-6">
          <Link to="/impressum" className="text-[#d4af37] hover:underline">
            Impressum
          </Link>{' '}
          ·{' '}
          <Link to="/privacidad" className="text-[#d4af37] hover:underline">
            Política de Privacidad
          </Link>
        </p>
      </div>
    </div>
  );
}
